"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddMembersCallback = void 0;
const react_1 = require("react");
const domain_1 = require("@home-health-notify/domain");
const OrganizationContext_1 = require("../context/OrganizationContext");
const ApiHandler_1 = require("../utils/ApiHandler");
/**
 * Hook to create a callback function for adding members to a group.
 * This hook handles the API call logic and can be used by both web and mobile apps.
 *
 * @example
 * const { addMembersCallback, isLoading } = useAddMembersCallback({
 *   chatId: groupInfo.id,
 *   groupType: groupInfo.groupType,
 *   onSuccess: () => router.back(),
 * });
 *
 * // Pass to AddMemberChips or call directly
 * await onAddMembers(addMembersCallback);
 */
const useAddMembersCallback = ({ chatId, groupType, onSuccess, onError, }) => {
    const { selectedOrgUser } = (0, react_1.useContext)(OrganizationContext_1.OrganizationContext);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const addMembersCallback = (0, react_1.useCallback)((selectedMembers) => __awaiter(void 0, void 0, void 0, function* () {
        // Nothing to add members to — the caller must not treat this as success.
        if (!chatId) {
            throw new Error("handledError");
        }
        setIsLoading(true);
        try {
            const isBroadcastGroup = groupType === domain_1.GROUP_TYPE.BROADCAST;
            if (isBroadcastGroup) {
                yield (selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getBroadcastChatManager().addMembers(selectedMembers, chatId));
            }
            else {
                yield (selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getPatientChatManager().addMembers(selectedMembers, chatId));
            }
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
        catch (e) {
            if (onError) {
                onError(e);
            }
            else {
                (0, ApiHandler_1.ApiErrorHandler)(e);
            }
            // Rethrow so the caller (SelectedMembersBar) doesn't navigate away on
            // failure — the toast above already surfaced the error once.
            throw new Error("handledError");
        }
        finally {
            setIsLoading(false);
        }
    }), [chatId, groupType, selectedOrgUser, onSuccess, onError]);
    return {
        addMembersCallback,
        isLoading,
    };
};
exports.useAddMembersCallback = useAddMembersCallback;
